import ApiService from '../common/api.service'
import {
  GETOVENDORLIST, GETVENDORBYYID
} from './actions.type'
import { SET_VENDORLIST, SET_ERROR } from './mutations.type'

const state = {
  errors: null,
  vendorList: [],
  errorMessage: null,
  errorType: null
}

const getters = {
  vendorList () {
    return state.vendorList
  },
  error (state) {
    return state.error
  },
  errorMessage (state) {
    return state.errorMessage
  },
  errorType (state) {
    return state.errorType
  }
}

const actions = {
  [GETOVENDORLIST] (context) {
    ApiService.setHeader()
    return ApiService.get('vendors', `?page_size=100000`)
      .then(({ data }) => {
        console.log(data)
        context.commit(SET_VENDORLIST, data.results)
        return data.results
      })
      .catch(({ response }) => {
        console.log(response)
        context.commit(SET_ERROR, response)
      })
  },
  [GETVENDORBYYID] (context, payload) {
    ApiService.setHeader()
    return ApiService.get(`vendors`, `${payload.id}`)
      .then(({ data }) => {
        console.log(data)
        return data
      })
      .catch(({ response }) => {
        console.log(response)
        context.commit(SET_ERROR, response)
      })
  }
}

const mutations = {
  [SET_ERROR] (state, error) {
    state.errors = error.data
    state.errorMessage = error.data
    state.errorType = error.status + ': ' + error.statusText
  },
  [SET_VENDORLIST] (state, vendorList) {
    state.vendorList = vendorList
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
